import { getFilterQuery, getUserGroupFilterQuery, getUserParentGroupFilterQuery } from "./helper";

import api from "./api";

export async function getGroupSearchDetails(
    search,
    loadedOptions,
    props,
    selectedCompany,
    filter,
    auth,
    groupFilter = true
) {
    console.log('group start======');
    let limit = 10;
    let page = Math.round(loadedOptions.length / limit);
    let hasMore = true;
    let apiPath = "groups?page=" + page + "&limit=" + limit;
    if (search && search != "") {
        apiPath = apiPath + "&search_name=" + encodeURIComponent(search);
    }
    if (props && props.parentGroupId && props.parentGroupId.value != -1) {
        apiPath = apiPath + "&filter_parentGroupId=" + props.parentGroupId.value;
    }
    if (props && props.multiParentGroupId) {
        let parentId = props.multiParentGroupId.map(key => key.value)
        apiPath = apiPath + "&filter_parentGroupId=" + parentId.toString();
    }

    if (selectedCompany != null) {
        apiPath += "&filter_companyId=" + selectedCompany.id;
    }
    if (auth.groupId && groupFilter && 0 < auth.groupId.length) {
        apiPath = apiPath + "&filter_id=" + auth.groupId.toString();
    }
    apiPath = apiPath + "&sort_name=asc";
    console.log('apiPath===', apiPath);
    let response = await api.getApi(apiPath);

    let searchList = [];

    if (response.status == "success") {
        let rowData = response.data.rows;
        for (let data of rowData) {
            searchList.push({
                ...data,
                value: data.id,
                key: data.id,
                label: data.name
            });
        }
    }
    const totalCount = loadedOptions.length + searchList.length;

    if (filter === true && loadedOptions.length === 0 && totalCount > 0) {
        searchList.unshift({ value: -1, label: "Todos" });
    }

    if (response.data?.count <= totalCount) {
        hasMore = false;
    }

    return {
        options: searchList,
        hasMore
    };
};

export async function getParentGroupDetails(
    search,
    loadedOptions,
    props,
    selectedCompany,
    filter,
    auth,
    groupFilter = true
) {
    const limit = 10;
    const page = Math.round(loadedOptions.length / limit);
    let hasMore = true;
    let apiPath = `parentgroups?page=${page}&limit=${limit}`;

    if (search && search !== "") {
        apiPath += `&search_name=${encodeURIComponent(search)}`;
    }
    if (selectedCompany != null) {
        apiPath += "&filter_companyId=" + selectedCompany.id;
    }
    if (auth && auth.parentGroupId) {
        apiPath += `&filter_id=${auth.parentGroupId}`;
    }
    apiPath += "&sort_name=asc";
    console.log('apiPath====', apiPath)
    const response = await api.getApi(apiPath);
    const searchList = [];
    console.log('response===', response)
    if (response.status === "success") {
        const rowData = response.data.rows;
        for (let data of rowData) {
            searchList.push({
                ...data,
                value: data.id,
                label: data.name
            });
        }
    }

    const totalCount = loadedOptions.length + searchList.length;

    if (filter === true && loadedOptions.length === 0 && totalCount > 0) {
        searchList.unshift({ value: -1, label: "Todos" });
    }

    if (response.data?.count <= totalCount) {
        hasMore = false;
    }

    return {
        options: searchList,
        hasMore
    };
}

export async function getEquipmentFilterDetails(
    search,
    loadedOptions,
    props,
    selectedCompany,
    filter,
    distinct,
    authUser
) {
    try {
        let limit = 10;
        let page = Math.round(loadedOptions.length / limit);
        let hasMore = true;
        let apiPath = "equipment?page=" + page + "&limit=" + limit + "&filter_disabled=false";
        if (search && search != "") {
            const s = encodeURIComponent(search);
            if (props && props.internal) {
                apiPath = apiPath + "&search_name=" + s + "&search_registerNumber=" + s;
            } else if (distinct && distinct != null) {
                apiPath = apiPath + "&search_" + distinct + "=" + s;
            } else {
                apiPath = apiPath + "&search_name=" + s;
            }
        }
        if (selectedCompany != null) {
            apiPath += "&filter_companyId=" + selectedCompany.id;
        }

        apiPath = apiPath + getUserGroupFilterQuery("groupId", undefined, authUser);
        console.log('apiPath===', apiPath, 'distinct=====', distinct)
        if (props) {
            if (props.routes && props.routes.equipmentId) {
                console.log('props.routes====', props.routes);
                apiPath = apiPath + "&filter_id=" + props.routes.equipmentId.toString();
            }
            if (props.equipmentType && props.equipmentType.value != -1) {
                apiPath = apiPath + "&filter_type=" + props.equipmentType.value;
            }
            if (props.make && props.make.value != -1) {
                apiPath = apiPath + "&filter_make=" + props.make.value;
            }
            if (props.model && props.model.value != -1) {
                apiPath = apiPath + "&filter_model=" + props.model.value;
            }
            if (props.group && props.group.value != -1 && (props.kpiequipments == null || props.kpiequipments.length == 0)) {
                apiPath = apiPath + "&filter_id=" + (props.group.equipmentId.toString() == "" ? "-1" : props.group.equipmentId);
            } else if (props.parentGroupId && props.parentGroupId.value != -1) {
                apiPath = apiPath + getUserParentGroupFilterQuery("groupId", props.parentGroupId.value, authUser);
            }
            if (props.region && props.region.value != -1) {
                apiPath = apiPath + "&filter_regionId=" + props.region.value;
            }
            if (props.registerNumberList) {
                apiPath = apiPath + "&filter_registerNumber=" + props.registerNumberList;
            }
            if (props && props.shareEquipment != undefined) {
                apiPath = apiPath + "&shareequipment=" + props.shareEquipment;
            }
            if (props.kpiequipments && 0 < props.kpiequipments.length) {
                if (props.group && props.group.value != -1) {
                    let groupEquipmentId = props.group.equipmentId;
                    let ids = [];
                    for (let item of groupEquipmentId) {
                        if (props.kpiequipments.indexOf(item) != -1) {
                            ids.push(item);
                        }
                    }
                    apiPath = apiPath + "&filter_id=" + (ids.toString() == "" ? "-1" : ids.toString());
                } else {
                    apiPath = apiPath + "&filter_id=" + props.kpiequipments.toString();
                }
            }
        }
        if (distinct && distinct != null) {
            apiPath = apiPath + "&distinct=" + distinct;
        }
        console.log("apiPath=55==", apiPath);
        const response = await api.getApi(apiPath);
        const searchList = [];

        if (response.status === "success" && response.data?.rows) {
            for (let data of response.data.rows) {
                if (data[distinct]) {
                    searchList.push({
                        ...data,
                        value: data[distinct],
                        id: data.id,
                        key: data[distinct],
                        label: props?.internal
                            ? `${data.name || ''}-${data.registerNumber || ''}`
                            : data[distinct] || ''
                    });
                }
            }
        }

        const totalCount = loadedOptions.length + searchList.length;

        if (filter === true && loadedOptions.length === 0 && totalCount > 0) {
            searchList.unshift({ value: -1, label: "Todos" });
        }

        if (response.data?.count <= totalCount) {
            hasMore = false;
        }

        return {
            options: searchList,
            hasMore
        };
    } catch (error) {
        console.log('error====', error)
    }

}
